module.exports = __webpack_public_path__ + "static/img/bgk.de0bc0b5.png";